import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { SubscriptionLike, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CONFIG } from '../../helper/app-config';
import { PlanogramService } from 'src/services/planogram.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-guidelines-input',
  templateUrl: './guidelines-input.component.html',
  styleUrl: './guidelines-input.component.css',
})
export class GuidelinesInputComponent implements OnInit {
  dataSource = new MatTableDataSource();
  isDisabled: boolean = false;
  @Output() checkNpdsValidationInGuidelines = new EventEmitter();
  columns = ['no', 'sku_img', 'dropdown', 'sku_face'];
  data = [{ sku_img: 'sku1', sku_name: 'coco cola', sku_face: 3 }];
  guidelines_input_subscribtion: SubscriptionLike;
  categories = ['UF', 'Mandatory', 'Strategic', 'Stills', 'ONS'];
  guidelines_input_observable: Observable<any> =
    this.planogramState.guidelines_input;
  guidelines_input: any = {};
  selectedCategory = 'UF';
  npds_dropdown_value: any = [];
  npds_dropdown_selected: any = [];
  selected_npds_from_data: any = [];
  max_facings: number;
  min_facings: number;
  planogram_id: number;
  isLibrary: boolean = false;
  isNPDSelected: number;
  sku_images_array: any = [];

  @Input() is_display = false;
  constructor(
    private planogramState: PlanogramStateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: PlanogramService,
    private sanitizer: DomSanitizer
  ) {
    this.activatedRoute.params.subscribe((params) => {
      let planogram_id = params['planogram_id'];
      const router_state =
        this.router.getCurrentNavigation()?.extras?.state?.['screen'] || '';
      this.isLibrary = router_state == 'library';
      this.planogram_id = planogram_id;
      if (this.planogram_id) {
        this.planogramState.getGuidelinesInput({ planogram_id: planogram_id });
      }
      console.log('guidelines screen');
    });
  }
  ngOnInit(): void {
    // let isNPDSelected: string = localStorage.getItem('isNPDSelected') ?? 'Yes';

    this.dataSource.data = this.data;
    if (!this.guidelines_input && this.planogram_id) {
      this.planogramState.getGuidelinesInput({
        planogram_id: this.planogram_id,
      });
    }
    this.guidelinesSuscription();
  }

  guidelinesSuscription() {
    this.guidelines_input_subscribtion =
      this.guidelines_input_observable.subscribe((res) => {
        if (res && res.sku_data) {
          this.guidelines_input = res;
          this.dataSource.data = res.sku_data[this.selectedCategory];
          this.getImages(res.sku_data[this.selectedCategory]);
          this.min_facings =
            this.guidelines_input['sku_data'].npds.minimum_facings;
          this.max_facings =
            this.guidelines_input['sku_data'].npds.maximum_facings;
          this.setSelectedNpdsAndAvailableNpsInDropdDown();
          // this.checkNpdsValidation();
          this.npds_dropdown_value = res.sku_data.npds.NPDs;
          this.isNPDSelected = res.npd_selection;
          console.log('isNPDSelected', this.isNPDSelected);
          this.isDisabled = this.isNPDSelected === 0;
          if (this.isNPDSelected === 0) {
            this.checkNpdsValidationInGuidelines.emit({ valid: true });
          } else {
            this.checkNpdsValidationInGuidelines.emit({ valid: false });
          }
        }
      });
  }

  setSelectedNpdsAndAvailableNpsInDropdDown() {
    this.selected_npds_from_data = this.guidelines_input['sku_data'].NPD;
    let no_of_dropdowns = this.max_facings / this.min_facings;
    console.log('no_of_dropdowns', no_of_dropdowns);
    let data = [];
    for (let i = 0; i < no_of_dropdowns; i++) {
      if (
        this.isLibrary &&
        this.selected_npds_from_data &&
        this.selected_npds_from_data[i] &&
        this.selected_npds_from_data[i].base_facings &&
        this.selected_npds_from_data[i].base_facings > 0
      ) {
        let obj: any = {};
        console.log(',,,,,,,,,,,,', this.npds_dropdown_value);
        let findNpdsIdfromDropDownValues: any = {};
        this.npds_dropdown_value.forEach((npd: any) => {
          if (npd.product_name == this.selected_npds_from_data[i].sku_face) {
            findNpdsIdfromDropDownValues = npd;
          }
        });
        obj.facings = this.selected_npds_from_data[i].base_facings;
        obj.product_name = this.selected_npds_from_data[i].sku_face;
        console.log(
          'findNpdsIdfromDropDownValues',
          findNpdsIdfromDropDownValues
        );
        obj.product_id = findNpdsIdfromDropDownValues.product_id;
        obj.sku_image_uri = this.selected_npds_from_data[i].sku_image_uri;
        data.push(obj);
      } else data.push({ facings: 0, product_name: '' });
    }
    this.npds_dropdown_selected = data;
  }

  changeCategory(category: string) {
    this.selectedCategory = category;
    if (this.selectedCategory == 'npds') {
      this.setSelectedNpdsAndAvailableNpsInDropdDown();
      this.dataSource.data = this.npds_dropdown_selected;
      this.getImages(this.npds_dropdown_selected);
    } else {
      this.dataSource.data =
        this.guidelines_input['sku_data'][this.selectedCategory];
      this.getImages(this.guidelines_input['sku_data'][this.selectedCategory]);
    }
  }

  selectNpds(npd: any, i: number) {
    this.npds_dropdown_selected[i] = { facings: 2, ...npd };
    this.dataSource.data = this.npds_dropdown_selected;
    this.getImages(this.npds_dropdown_selected);
    this.checkNpdsValidation();
    console.log('this.npds_dropdown_selected', this.npds_dropdown_selected);
  }

  incrementNpdFacings(data: any, i: number) {
    if (data.facings < this.max_facings) {
      let increment = this.npds_dropdown_selected[i].facings++;
      this.npds_dropdown_selected[i] = {
        facings: increment,
        ...this.npds_dropdown_selected[i],
      };
      this.dataSource.data = this.npds_dropdown_selected;
      this.getImages(this.npds_dropdown_selected);
      this.checkNpdsValidation();
    }
    console.log('data---------------', this.npds_dropdown_selected);
  }

  decrementNpdFacings(data: any, i: number) {
    if (data.facings > 0) {
      let decrement = this.npds_dropdown_selected[i].facings--;
      this.npds_dropdown_selected[i] = {
        facings: decrement,
        ...this.npds_dropdown_selected[i],
      };
      this.getImages(this.npds_dropdown_selected);
      this.dataSource.data = this.npds_dropdown_selected;
      this.checkNpdsValidation();
    }
    console.log('data---------------', this.npds_dropdown_selected);
  }

  saveNpdsData() {
    console.log('npds data', this.npds_dropdown_selected);
    let payload: any = {};
    let npds =
      this.isNPDSelected == 0
        ? this.noNPDSelectedData()
        : this.sumSameNameNpds();
    payload.planogram_id = this.planogram_id;
    payload.NPDs = npds;
    payload.min_facings = this.min_facings;
    payload.max_facings = this.max_facings;
    this.planogramState.incorporate_npds(payload);
  }
  noNPDSelectedData() {
    return this.npds_dropdown_value.map((item: any) => ({
      ...item,
      facings: 0,
    }));
  }
  checkNpdsValidation() {
    let valid = false;

    this.npds_dropdown_selected.forEach((npd: any) => {
      valid = true;
      if (npd.facings == 0) valid = true;
      else if (npd.facings < this.min_facings) {
        valid = false;
        return;
      }
    });
    if (valid) {
      let sum = 0;
      this.npds_dropdown_selected.forEach((npd: any) => {
        sum = sum + npd.facings;
      });
      console.log('sum=========>', sum);
      if (sum === this.max_facings) valid = true;
      else valid = false;
    }
    console.log('checkNpdsValidation', valid);

    this.checkNpdsValidationInGuidelines.emit({ valid: valid });
  }

  sumSameNameNpds() {
    let array: any = [];
    this.npds_dropdown_selected.forEach((npd: any) => {
      let duplicateIndex: any = -1;
      if (array.length > 0) {
        array.forEach((n: any, i: number) => {
          if (n.product_id == npd.product_id) {
            duplicateIndex = i;
          } else duplicateIndex = -1;
          console.log('dupliacate index', duplicateIndex);
        });
      }
      if (duplicateIndex !== -1) {
        let sum = array[duplicateIndex].facings + npd.facings;
        array[duplicateIndex] = { ...array[duplicateIndex], facings: sum };
      } else array.push(npd);
    });
    return array;
  }

  renderHtml(value: string) {
    const boldTextPattern = /<b>(.*?)<\/b>/g;
    const segments = [];
    let lastIndex = 0;
    let match;

    // Extract segments, identifying <b> tags
    while ((match = boldTextPattern.exec(value)) !== null) {
      const beforeText = value.slice(lastIndex, match.index);
      const boldText = match[1];
      lastIndex = match.index + match[0].length;

      // Push regular text and bold text segments separately
      if (beforeText) segments.push({ text: beforeText, isBold: false });
      if (boldText) segments.push({ text: boldText, isBold: true });
    }

    // Add remaining text after the last match
    const afterText = value.slice(lastIndex);
    if (afterText) segments.push({ text: afterText, isBold: false });

    return segments;
  }

  getImages(dataArray: any) {
    let imageArray: any = []; // Initialize the cooler_images array
    // Iterate through each image URL
    const imagePromises = dataArray.map((data: any, i: number) =>
      this.apiService.fetchImageFromBlob(data.sku_image_uri).toPromise()
    ); // Convert observables to promises
    // Use Promise.all to wait for all requests to complete
    this.sku_images_array = dataArray.map((v: any, i: number) =>
      dataArray[i].sku_image_uri ? 'loading' : ''
    );

    Promise.all(imagePromises)
      .then((responses: Blob[]) => {
        this.sku_images_array = responses.map((res) =>
          URL.createObjectURL(res)
        );
        console.log('Images fetched and set:', this.sku_images_array);
      })
      .catch((error) => {
        console.error('Error fetching images:', error);
      });
  }

  moveBack() {
    this.router.navigateByUrl(CONFIG.PATH.PLANOGRAMS, {
      state: { screen_index: 0, screen: 'planogram-list' },
    });
  }
}
